module.exports = __webpack_public_path__ + "static/media/entertainment.4f75e655.jpg";